export default __webpack_public_path__ + "static/media/svg-1.c4804de6.svg";